import React from 'react';

const NotAuthorized = ({ children }) =>{
    return <div>{children}</div>
}

export default NotAuthorized;